import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import EventGalleryList from "./EventGalleryList";
import LeftArrow from "../../assets/images/committee/ArrowLeft.svg";
import API from "../../config/axios";
import { api_paths } from "../../config/api.paths";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../../redux/user";
import { useNavigate } from "react-router-dom";

const EventDetailsPage = ({ eventId }) => {
  const [galleryData, setGalleryData] = useState([]);
  const [eventDetail, setEventDetail] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        dispatch(SET_LOADING(true));

        const url = `${api_paths.member.EVENTS.EVENT_GALLERY_PAGE.GET_EVENT_IMAGES}/${eventId}`;

        const response = await API.get(url);

        setGalleryData(response.data?.payload?.data);
        setEventDetail(response.data?.payload?.dataDoc);
      } catch (error) {
        console.error("Error fetching event gallery:", error);
      } finally {
        dispatch(SET_LOADING(false));
      }
    };

    fetchGalleryData();
    //eslint-disable-next-line
  }, [eventId]);

  return (
    <Container className="py-5">
      <img
        src={LeftArrow}
        alt="back-arrow"
        className="cursor-pointer"
        onClick={() => {
          navigate(-1);
        }}
      />
      <Row className="mb-4">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="inter-bold h1">{eventDetail?.title}</h1>
            <p>{eventDetail?.caption}</p>
          </div>
        </Col>
      </Row>

      {galleryData.length > 0 && (
        <EventGalleryList data={galleryData} eventDetail={true} />
      )}
    </Container>
  );
};

export default EventDetailsPage;
